// Shared brand-image fallback chain for all chrome surfaces (sidebars, header,
// receipts) so multi-tenant admin deploys never accidentally show the platform
// logo when a tenant has uploaded their own. Order is intentional:
//   1. logoUrl     — full brand mark from Business Settings
//   2. feviconUrl  — tenant favicon (always uploaded even when logo isn't)
//   3. /webdekho_logo.png — last-resort platform default
const PLATFORM_FALLBACK = '/webdekho_logo.png';

export const resolveBrandLogo = (logoUrl, feviconUrl) =>
  logoUrl || feviconUrl || PLATFORM_FALLBACK;

// Returns an onError handler that walks the fallback chain. Each step is taken
// at most once — once we land on the platform fallback we either show it or
// hide the slot, never loop.
export const handleBrandLogoError = (feviconUrl) => (e) => {
  const cur = e.currentTarget.src || '';
  if (feviconUrl && !cur.endsWith(feviconUrl)) {
    e.currentTarget.src = feviconUrl;
    return;
  }
  if (!cur.endsWith(PLATFORM_FALLBACK)) {
    e.currentTarget.src = PLATFORM_FALLBACK;
    return;
  }
  e.currentTarget.style.display = 'none';
};
